export enum DatatableStaticTemplateType {
  None,
  EasternDateTemplate,
  EasternDateTimeTemplate,
  UtcDateTemplate,
  UtcDateTimeTemplate,
  CurrencyTemplate,
  YesNoTemplate,
  FeinTemplate,
  // These two need to be implemented in datatable-component.html
  EntityTemplate, // Depends on entityId, entityTypeId
  // TransactionTemplate, // Depends on transactionId, transactionTypeId
  CheckboxTemplate,
  PhoneNumberTemplate,
  PriorityTagTemplate,
  ActiveInactiveTemplate,
  UtcDateTimeHMSTemplate,
  EasternDateTimeHMSTemplate,
  CaseNumberTemplate,
  FormNameTemplate,
}
